import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  formDataPost,
  formDataPut,
  get,
  patch,
  post,
  put,
} from "helpers/api_helper";

import {
  GET_ALL_ORGANISATION,
  UPDATE_ORGANISATION_STATUS,
  GET_ORGANISATION_DETAILS,
  INVITE_ORGANISATION,
  ORGANIZATION_SETTING_DETAILS,
  UPDATE_ORGANIZATION_SETTING,
  GET_ORGANIZATION_MANAGER_DETAILS,
  UPDATE_ORGANIZATION_MANAGER,
  GET_ORGANISATION_LIST,
} from "helpers/url_helper";


export const getOrganistionList = createAsyncThunk(
  GET_ORGANISATION_LIST,
  async () => {
    const response = await get(GET_ORGANISATION_LIST);
    return response;
  }
);

export const getAllOrganisation = createAsyncThunk(
  GET_ALL_ORGANISATION,
  async (payload) => {
    const response = await post(GET_ALL_ORGANISATION, payload);
    return response;
  }
);

export const getOrganisationDetails = createAsyncThunk(
  GET_ORGANISATION_DETAILS,
  async (payload) => {
    const response = await post(GET_ORGANISATION_DETAILS, payload);
    return response;
  }
);

export const updateOrganisationStatus = createAsyncThunk(
  UPDATE_ORGANISATION_STATUS,
  async (payload) => {
    const response = await patch(UPDATE_ORGANISATION_STATUS, payload);
    return response;
  }
);

export const inviteOrganitation = createAsyncThunk(
  INVITE_ORGANISATION,
  async (payload) => {
    const response = await formDataPost(INVITE_ORGANISATION, payload);
    return response;
  }
);

export const getOrganizationSettingsDetails = createAsyncThunk(
  ORGANIZATION_SETTING_DETAILS,
  async (payload) => {
    const response = await post(ORGANIZATION_SETTING_DETAILS, payload);
    return response;
  }
);

export const updateOrganizationSettings = createAsyncThunk(
  UPDATE_ORGANIZATION_SETTING,
  async (payload) => {
    const response = await formDataPut(UPDATE_ORGANIZATION_SETTING, payload);
    return response;
  }
);

export const getOrganizationManagerDetails = createAsyncThunk(
  GET_ORGANIZATION_MANAGER_DETAILS,
  async (payload) => {
    const response = await post(GET_ORGANIZATION_MANAGER_DETAILS, payload);
    return response;
  }
);

export const updateOrganizationManager = createAsyncThunk(
  UPDATE_ORGANIZATION_MANAGER,
  async (payload) => {
    const response = await put(UPDATE_ORGANIZATION_MANAGER, payload);
    return response;
  }
);
